import { Button } from '@progress/kendo-react-buttons';
import { Window } from '@progress/kendo-react-dialogs';
import { Checkbox, TextBox } from '@progress/kendo-react-inputs';
import React from 'react';
import useMap from '../../app/hooks/use-map';
import { RefreshOutline } from '../../icons/icons';
import useSelectedWeather from './hooks/use-selected-weather';

const c = [
    '#40DAFB ',
    '#2E348B ',
    '#E8A9C8',
    '#E73580 ',
    '#6608BC ',
    '#79DEFC ',
    '#CB6D48',
    '#dddddd',
    '#D2449C ',
    '#8AB7ED ',
    '#ff0000',
    '#BEF0E7 ',
    '#93B1BC ',
    '#088080',
    '#C93FC4 ',
    '#D3640C ',
    '#ABB3DD ',
    '#454482',
    '#4F1837',
    '#DC0B35 '
];
const o: Record<string, string> = {};

function color(id: string) {
    if (!id.includes('fe-weather')) {
        return '';
    }
    const split = id.split('-')[2];
    if (!o[split]) {
        o[split] = c[Object.keys(o).length];
    }

    return o[split];
}

const LayerDebugger = (props: { onClose: () => void }) => {
    const map = useMap();
    const selectedProducts = useSelectedWeather();
    const [order, setOrder] = React.useState<{ name: string; source?: 'febase' | 'festatic' | 'other'; visibility: string }[]>([]);
    const [showStatic, setShowStatic] = React.useState(false);
    const [showBase, setShowBase] = React.useState(false);
    const [showNotStyle, setShowNotStyle] = React.useState(true);

    const [filter, setFilter] = React.useState('');

    const loadStuff = () => {
        if (map) {
            const order = map.getLayersOrder();
            setOrder(
                order.map((x) => {
                    const source = map.getLayer(x)?.source;
                    return {
                        name: x,
                        source: source === 'febase' || source === 'festatic' ? source : 'other',
                        visibility: map.getLayoutProperty(x, 'visibility') as string
                    };
                })
            );
        }
    };
    React.useEffect(() => {
        loadStuff();
    }, [map, selectedProducts]);

    React.useEffect(() => {
        return map?.on('styledata', loadStuff).unsubscribe;
    }, [map]);

    const changeVis = React.useCallback(
        (id: string, value: boolean) => {
            map?.setLayoutProperty(id, 'visibility', value ? 'none' : 'visible');

            self.setTimeout(() => loadStuff(), 0);
        },
        [map, loadStuff]
    );

    return (
        <Window title={'Layer debugger'} draggable={true} onClose={props.onClose} initialHeight={800} initialWidth={600}>
            <div className="d-flex flex-column h-100 gap-0">
                <div>
                    <div className="d-flex gap-2">
                        <TextBox placeholder="Filter" value={filter} onChange={(e) => setFilter(e.value as string)} />
                        <Button onClick={loadStuff} svgIcon={RefreshOutline} title="Refresh" fillMode={'outline'} />
                    </div>
                    <div className="d-flex gap-2 pt-2 align-items-center">
                        <Checkbox label="febase" value={showBase} onChange={(e) => setShowBase(e.value)} />
                        <Checkbox label="festatic" value={showStatic} onChange={(e) => setShowStatic(e.value)} />
                        <Checkbox label="other" value={showNotStyle} onChange={(e) => setShowNotStyle(e.value)} />
                        <Button onClick={() => ((window as any).map = map)}>Pin map</Button>
                    </div>
                </div>
                <div>Layers:</div>
                <div className="font-mono d-flex flex-wrap flex-column h-100 overflow-auto" style={{ fontSize: '0.8em' }}>
                    {order
                        .filter((x) => (filter ? x.name.includes(filter) : true))
                        .filter(
                            (x) =>
                                (showBase && x.source === 'febase') ||
                                (showStatic && x.source === 'festatic') ||
                                (showNotStyle && x.source === 'other')
                        )
                        .map((x, i) => (
                            <div style={{ color: color(x.name) }} key={i}>
                                <Checkbox
                                    key={x.name}
                                    onChange={() => changeVis(x.name, x.visibility !== 'none')}
                                    disabled={x.name.includes('slot')}
                                    checked={x.visibility !== 'none'}
                                    label={
                                        <>
                                            <strong>[{x.name.includes('slot') ? 'slot' : x.source}]</strong>
                                            <span> {x.name}</span>
                                            <span className={x.visibility === 'visible' ? 'text-success' : 'text-danger'}>
                                                {' '}
                                                [{x.visibility || '???'}]
                                            </span>
                                        </>
                                    }
                                />
                            </div>
                        ))}
                </div>
            </div>
        </Window>
    );
};

export default LayerDebugger;
